import React from 'react';
import PropTypes from 'prop-types';
import { useTranslate } from '@gameday/utils/hooks/useTranslate';
const DIVISIONRANK_KEY_PREFIX = 'standings_ranking_';
const SHORTNAME_KEY_PREFIX = 'division_';
const FALLBACK = '';

const StandingText = ({
    divisionRank ='',
    nameShort = ''
}) => {
    const translate = useTranslate();
    const hasKeyName = divisionRank && nameShort;

    if (!hasKeyName) {
        return null;
    }

    const divisionKey = `${DIVISIONRANK_KEY_PREFIX}${divisionRank ?? FALLBACK}`;
    const shortNameKey = `${SHORTNAME_KEY_PREFIX}${nameShort?.toLowerCase().split(' ').join('_') ?? FALLBACK}`;
    const translatedStandingsText = `${translate(divisionKey, `${divisionRank ?? FALLBACK}`)} ${translate(shortNameKey, `${nameShort ?? FALLBACK}`)}`;

    return (
        <>{translatedStandingsText}</>
    )    
};

StandingText.propTypes = {
    divisionRank: PropTypes.string,
    nameShort : PropTypes.string
};


export default StandingText;
